import { Factory, trait } from 'miragejs';

export default Factory.extend({
  brand: 'Visa',
  last4: 1234,

  isAch: trait({
    brand: null,
    last4: null,
    type: 'virtual_bank_account',
  }),

  // this trait is redundant with the default values but allows tests to be
  // explicit about CC vs. ACH when creating a payment-source.
  isCC: trait({
    brand: 'Visa',
    last4: 1234,
  }),
});
